/* eslint-disable no-underscore-dangle */
import actions from './actions'

const initialState = {
  DomainList: null,
  searchThirdParty: null,
  loading: false,
  creating: false,
  updating: false,
  removing: false,
}

export default function thirdpartyReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
